import PropTypes from 'prop-types';
import { cloneElement, Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { OrderedMap, List, Map as ImmutableMap } from 'immutable';
import partial from 'transmute/partial';
import debounce from 'transmute/debounce';
import { CONTENT_TYPE_FIELD } from 'SalesContentIndexUI/data/constants/SearchFields';
import SearchStatusValues from 'SalesContentIndexUI/data/constants/SearchStatus';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import SearchQueryRecord from 'SalesContentIndexUI/data/records/SearchQueryRecord';
import filter from 'SalesContentIndexUI/data/utils/filter';
import DefaultSort from 'SalesContentIndexUI/data/lib/DefaultSort';
import FolderActions from 'SalesContentIndexUI/data/actions/FolderActions';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { FolderNav, FolderNavItem } from 'foundations-components/transitional/components/FolderNav';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Fo... Remove this comment to see the full error message
import FolderNavSelectedCopy from './FolderNavSelectedCopy';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Fo... Remove this comment to see the full error message
import FolderNavNoFolderItem from './FolderNavNoFolderItem';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Fo... Remove this comment to see the full error message
import FolderNavFooter from './FolderNavFooter';
import { H2 } from 'foundations-components/transitional/components/H2';
import { FolderIcon } from 'foundations-assets/icons/components/FolderIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
let _pendingFolderFetch = null;
export default ((searchFetch, folderContentType) => {
  FolderActions.init(searchFetch);
  const folderSearch = FolderActions.get('search');
  class FolderNavModal extends Component {
    constructor(props) {
      super(props);
      this.state = {
        selectedFolder: null,
        folderSearchResults: OrderedMap(),
        folderSearchQuery: new SearchQueryRecord({
          offset: 0,
          limit: 20,
          filters: List([filter(CONTENT_TYPE_FIELD, folderContentType)]),
          sorts: List([DefaultSort])
        }),
        hasMore: true,
        folderSearchStatus: SearchStatusValues.LOADING
      };
      this.fetchFolders = () => {
        if (_pendingFolderFetch) {
          return;
        }
        this.setState({
          folderSearchStatus: SearchStatusValues.LOADING
        });
        _pendingFolderFetch = folderSearch(this.state.folderSearchQuery).then(({
          hasMore,
          results
        }) => {
          this.setState(({
            folderSearchResults
          }) => ({
            hasMore,
            folderSearchResults: folderSearchResults.merge(results),
            folderSearchStatus: SearchStatusValues.SUCCEEDED
          }));
        }).finally(() => {
          _pendingFolderFetch = null;
        });
      };
      this.fetchMoreFolders = () => {
        if (!this._folderNav) {
          console.error('folderNav element not defined');
          return;
        }
        const {
          hasMore
        } = this.state;
        const {
          scrollTop,
          scrollHeight,
          clientHeight
        } = this._folderNav;
        const isCloseToBottom = scrollTop + clientHeight + 50 >= scrollHeight;
        if (hasMore && isCloseToBottom) {
          this.setState(({
            folderSearchQuery
          }) => ({
            folderSearchQuery: folderSearchQuery.set('offset', folderSearchQuery.offset + folderSearchQuery.limit)
          }), this.fetchFolders);
        }
      };
      this.setSelectedFolder = selectedFolder => {
        this.setState({
          selectedFolder
        });
      };
      this.isInitialFetchLoading = () => {
        const {
          hasMore,
          folderSearchStatus,
          folderSearchResults
        } = this.state;
        return folderSearchStatus === SearchStatusValues.LOADING && hasMore && folderSearchResults.isEmpty();
      };
      this.handleMoveClick = () => {
        const {
          selectedFolder
        } = this.state;
        this.props.onConfirm(selectedFolder);
      };
      this.setFolderSearchQuery = ({
        target: {
          value
        }
      }) => {
        this.setState(({
          folderSearchQuery
        }) => ({
          hasMore: true,
          folderSearchResults: OrderedMap(),
          folderSearchQuery: folderSearchQuery.merge({
            query: value,
            offset: 0
          }),
          folderSearchStatus: SearchStatusValues.LOADING
        }), this.debouncedFetchFolders);
      };
      this.renderFolderLoading = () => {
        if (!this.state.hasMore) {
          return null;
        }
        return /*#__PURE__*/_jsx(TFlex, {
          align: "center",
          children: /*#__PURE__*/_jsx(LoadingSpinner, {
            grow: true,
            minHeight: 50
          })
        });
      };
      this.renderAlert = () => {
        // @ts-expect-error cloneElement type is weird
        return this.props.alert ? /*#__PURE__*/cloneElement(this.props.alert) : null;
      };
      this.renderFolders = () => {
        if (this.isInitialFetchLoading()) {
          return null;
        }
        return this.state.folderSearchResults.map(folderSearchResult => {
          return /*#__PURE__*/_jsx(FolderNavItem, {
            open: false,
            value: folderSearchResult.contentId,
            title: folderSearchResult.name || '',
            onClick: partial(this.setSelectedFolder, folderSearchResult),
            iconLeft: FolderIcon
          }, `folder-nav-item-${folderSearchResult.contentId}`);
        }).toList();
      };
      this.debouncedFetchFolders = debounce(300, this.fetchFolders);
    }
    componentDidMount() {
      this.fetchFolders();
      const folderNavElement = document.querySelector('[data-test-id="move-data-item-modal-folder-nav"]');
      if (folderNavElement) {
        this._folderNav = folderNavElement;
        this._folderNav.addEventListener('scroll', this.fetchMoreFolders);
        this._folderNav.addEventListener('resize', this.fetchMoreFolders);
      }
    }
    componentWillUnmount() {
      if (this._folderNav) {
        this._folderNav.removeEventListener('scroll', this.fetchMoreFolders);
        this._folderNav.removeEventListener('resize', this.fetchMoreFolders);
      }
    }
    render() {
      const {
        selectedFolder,
        folderSearchQuery
      } = this.state;
      const {
        searchResult,
        searchResults,
        onClose
      } = this.props;
      return /*#__PURE__*/_jsxs(Modal, {
        size: "auto",
        onEsc: onClose,
        children: [/*#__PURE__*/_jsxs(DialogHeader, {
          children: [/*#__PURE__*/_jsx(DialogCloseButton, {
            onClick: onClose
          }), /*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "salesContentIndexUI.tableRowHoverButtons.moveFolders"
            })
          })]
        }), /*#__PURE__*/_jsxs(DialogBody, {
          children: [this.renderAlert(), /*#__PURE__*/_jsx(SearchInput, {
            value: folderSearchQuery.query,
            onChange: this.setFolderSearchQuery,
            marginBlockEnd: "300"
          }), /*#__PURE__*/_jsx(FolderNavSelectedCopy, {
            searchResult: searchResult,
            searchResults: searchResults,
            selectedFolder: selectedFolder
          }), /*#__PURE__*/_jsxs(FolderNav, {
            value: selectedFolder && selectedFolder.contentId,
            "data-test-id": "move-data-item-modal-folder-nav",
            children: [/*#__PURE__*/_jsx(FolderNavNoFolderItem, {
              isInitialFetchLoading: this.isInitialFetchLoading(),
              setSelectedFolder: this.setSelectedFolder
            }), this.renderFolders(), this.renderFolderLoading()]
          })]
        }), /*#__PURE__*/_jsx(DialogFooter, {
          children: /*#__PURE__*/_jsx(FolderNavFooter, {
            onConfirm: this.handleMoveClick,
            onClose: onClose,
            selectedFolder: selectedFolder
          })
        })]
      });
    }
  }
  FolderNavModal.propTypes = {
    searchResult: PropTypes.instanceOf(SearchResultRecord),
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof Map' is not assignable to... Remove this comment to see the full error message
    searchResults: PropTypes.instanceOf(ImmutableMap),
    alert: PropTypes.element
  };
  return FolderNavModal;
});